import React from 'react';
import { BET_ACTION_MODAL_TYPE } from '../../enums/betActionModal';

export const StatisticsPopup = ({ isShowBetActionModal, handleShowBetActionModal, isMobile,  }) => {
  return (
    <div className={`${isMobile() ? 'mob-roulette-t-icon-item' : 'right-top-icon-box'} 
              ${isShowBetActionModal === BET_ACTION_MODAL_TYPE.statistics ? 'active' : ''}`}
         onClick={() => handleShowBetActionModal(BET_ACTION_MODAL_TYPE.statistics)}
    >
      <span className="icon-statistics"/>
    </div>
  );
};